module.exports = __webpack_public_path__ + "assets/9c58ebf4caa161f8d8659cf674ae079b.png";